import { Component, OnInit, OnDestroy } from '@angular/core';

import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HelperService, CalculationService, DataService, HTTPService } from 'app/services';

import { Mitchell1ServiceAssignDialogComponent } from 'app/modules/estimate/components/mitchell1-assign-dialog/mitchell1-service-assign-dialog.component';

import { mileageUnits } from 'app/constants';
import { DateService } from 'app/services';
import { debounce, find, isEmpty } from 'lodash';
import { Subscription } from 'rxjs';
import { ScriptLoaderService } from 'app/services/script-loader.service';
import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
  selector: 'app-canned-service-browse',
  templateUrl: './canned-service-browse.component.html',
  styleUrls: ['./canned-service-browse.component.scss'],
  providers: [DialogService],
})
export class CannedServiceBrowseComponent implements OnInit, OnDestroy {
  orderStatus: string = '';
  activeTabIndex: number = 0;
  // 0 - Autoleap, 1 - Motor Serrvice
  serviceType: number = 0;
  openVehicleInSidepanel: any;
  query: string = '';
  isSearchFieldFocused: boolean = true;
  isMitchell1Loading: boolean = false;
  dataListener: Subscription;
  confirmationTitle: string = 'Deselecting the service?';
  confirmationContent: string = 'Deselecting the service will reset all the quantities permanently';
  unlinkVehicleMessage: string = 'Connect a vehicle to view MOTOR canned services';
  isMitchell1Connected: boolean = false;
  isMitchell1EstimatorEnabled: boolean = false;
  pricings: any = {};
  itemSettings: any = {};
  vehicle: any = {};
  motorVehicleId: string = '';
  isMotorServiceEnabled: boolean = true;
  isRepairDiagramEnabled: boolean = true;
  isMitchellIntegrationEnabled: boolean = false;
  isMotorGen2Enabled: boolean = true;
  isMotorServicesAvailable: boolean = false;
  isMotorGen2ServicesAvailable: boolean = false;
  motorVehicle: any = {};
  mileage: any = {
    value: '',
    unit: null,
  };

  selectedMotorServices: any = {};
  selectedMotorServicesNewGen: any = {};

  selectedInternalServices: any = {};
  selectedMaintenanceServices: any = {};
  selectedServiceInspection: any = {};
  customFleetSettings: any = {};
  services: any[] = [];
  searchCannedServices = debounce(this._searchCannedServices, 800);
  deferredServices: any[] = [];
  isDeferredServiceEnabled: boolean = false;
  selectedTab: number = 3;
  roNum: number = 0;
  serviceTags: any[] = [];
  isQuickServiceEnabled: boolean = false;
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  companyData: any;
  constructor(
    private dateService: DateService,
    private dynamicDialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private helperService: HelperService,
    public calculationService: CalculationService,
    private dataService: DataService,
    private httpService: HTTPService,
    private dialogService: DialogService,
    private scriptLoaderService: ScriptLoaderService,
  ) {}

  /** Fetching all services */
  ngOnInit() {
    const data = this.dialogConfig.data;
    this.roNum = data.roNum;

    this.services = this.helperService.deepCopy(data.services);
    this.currentLang = data.currentLang;
    this.companyLocalization = data.companyLocalization;

    if (data.customFleetSettings) {
      this.customFleetSettings = data.customFleetSettings;
    }

    if (data.deferredServices && data.deferredServices.length) {
      this.deferredServices = this.helperService.deepCopy(this.formatDeferredServices(data.deferredServices));
    }

    if (data.isFromDeferred) {
      this.activeTabIndex = 1;
    }

    if (data.openMotorService.motorService) {
      this.activeTabIndex = 2;
      this.serviceType = 1;
      this.query = data.openMotorService.searchQuery;
      this.searchCannedServices(this.query, true);
    }

    if (data && data.searchTerm) {
      this.query = data.searchTerm;
    }

    if (data.serviceTags) {
      this.serviceTags = data.serviceTags;
    }

    this.isDeferredServiceEnabled = this.dataService.isDeferredServiceEnabled;
    this.isMotorServiceEnabled = data.isMotorServiceEnabled;
    this.isMotorGen2Enabled = data.isMotorGen2Enabled;
    this.isMitchell1Connected = data.isMitchell1Connected;
    this.isMitchell1EstimatorEnabled = data.isMitchell1EstimatorEnabled;
    this.isRepairDiagramEnabled = this.dataService.isRepairDiagramEnabled;
    this.isMitchellIntegrationEnabled = this.dataService.isMitchellIntegrationEnabled;
    this.isQuickServiceEnabled = this.dataService.isQuickServiceEnabled;

    this.vehicle = data.vehicle || {};
    this.isMotorGen2ServicesAvailable = !!data?.vehicle?.vcDbApiResponse || !!data?.vehicle?.vcDbApiResponse?.vehicleToEngineConfigId;
    this.isMotorServicesAvailable = !!data?.vehicle?.apiResponse || !!data?.vehicle?.apiResponse?.BaseVehicleID;
    this.orderStatus = data.orderStatus;
    this.openVehicleInSidepanel = data.openVehicleInSidepanel;
    this.mileage.value = data.reading;

    if (data.mileageUnit) {
      this.mileage.unit = find(mileageUnits, { value: data.mileageUnit });
    } else if (this.dataService.defaultMileageUnit) {
      this.mileage.unit = find(mileageUnits, {
        value: this.dataService.defaultMileageUnit,
      });
    }

    if (this.vehicle.apiResponse && this.vehicle.apiResponse.BaseVehicleID) {
      this.motorVehicle = this.vehicle.apiResponse;
      this.motorVehicleId = this.vehicle.apiResponse.BaseVehicleID;

      this.getMotorTagPricings();
    }

    if (this.isMotorServiceEnabled && !this.motorVehicleId) {
      this.helperService.showToaster('error', this.unlinkVehicleMessage);
    }

    this.dataListener = this.dataService.getData().subscribe(({ data }) => {
      if (data.key === 'company-appdata-updated') {
        this.isDeferredServiceEnabled = this.dataService.isDeferredServiceEnabled;
        this.isRepairDiagramEnabled = this.dataService.isRepairDiagramEnabled;
        this.isMotorGen2Enabled = this.dataService.isMotorGen2Enabled;
        if (!this.mileage.unit) {
          this.mileage.unit = find(mileageUnits, {
            value: this.dataService.defaultMileageUnit,
          });
        }
      }

      if (data.type === 'sidebar' && data.tab === 'close' && data.data) {
        const { vehicle, type } = data.data;

        if (type === 'ro-vehicle' && vehicle && vehicle._id) {
          if (this.vehicle && this.vehicle.vehicleId === vehicle._id) {
            if (vehicle.apiResponse) {
              this.motorVehicle = vehicle.apiResponse;
              this.motorVehicleId = vehicle.apiResponse.BaseVehicleID;
            }
          }
        }
      }
    });
    this.companyData = this.helperService.getCompany();
  }

  ngOnDestroy() {
    if (this.dataListener) {
      this.dataListener.unsubscribe();
    }
  }

  getMotorTagPricings() {
    this.httpService.getDefaultMotorPricingsAndTags().then(
      (data) => {
        if (data.appsettings) {
          this.setMotorTypeSettings(data.appsettings, data.motorTag);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  setMotorTypeSettings(appsettings: any, motorTag: any) {
    const {
      pricingId,
      partPriceId,
      isTaxablePart,
      isTaxableLabor,
      isCommissionablePart,
      isCommissionableLabor,
      mBaseLaborCost,
      partQboItemRefId,
      laborQboItemRefId,
      percisionLaborCost,
      maintainenacePriceId,
      percisionLaborPriceId,
      maintainenaceLaborCost,
      displayDescOnOrderPart,
      displayHoursOnOrderPart,
      displayDescOnOrderLabor,
      displayHoursOnOrderLabor,
    } = appsettings.appsettings;
    const { motorLaborTimeMarkup } = appsettings;

    if (pricingId) {
      this.pricings.General = {
        price: pricingId.rate || 0,
        cost: mBaseLaborCost || 0,
        pricing: {
          pricingId: pricingId._id,
          name: pricingId.name,
        },
      };
    }

    if (percisionLaborPriceId) {
      this.pricings.Precision = {
        price: percisionLaborPriceId.rate || 0,
        cost: percisionLaborCost || 0,
        pricing: {
          pricingId: percisionLaborPriceId._id,
          name: percisionLaborPriceId.name,
        },
      };
    }

    if (maintainenacePriceId) {
      this.pricings.Maintenance = {
        price: maintainenacePriceId.rate || 0,
        cost: maintainenaceLaborCost || 0,
        pricing: {
          pricingId: maintainenacePriceId._id,
          name: maintainenacePriceId.name,
        },
      };
    }

    this.itemSettings.part = {
      motorTag: motorTag,
      isTaxable: isTaxablePart,
      commissionable: isCommissionablePart,
      displayHoursOnOrder: displayHoursOnOrderPart,
      displayDescOnOrder: displayDescOnOrderPart,
      qboId: (partQboItemRefId && partQboItemRefId.qboId) || '',
      pricing: partPriceId,
    };
    this.itemSettings.labor = {
      motorTag: motorTag,
      isTaxable: isTaxableLabor,
      commissionable: isCommissionableLabor,
      displayHoursOnOrder: displayHoursOnOrderLabor,
      displayDescOnOrder: displayDescOnOrderLabor,
      qboId: (laborQboItemRefId && laborQboItemRefId.qboId) || '',
    };

    this.itemSettings.motorLaborTimeMarkup = motorLaborTimeMarkup;
  }

  setServiceTotals(service: any) {
    const data = {
      hours: 0,
      parts: 0,
      tires: 0,
      other: 0,
      sublet: 0,
      partCost: 0,
      laborCost: 0,
      tireCost: 0,
      otherCost: 0,
      subletCost: 0,
      isAdded: false,
    };

    if (service.items && service.items.length) {
      service.items.forEach((item: any) => {
        if (item.type === 'labor') {
          data.hours += 1 * item.count;
          data.laborCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'part') {
          data.parts += 1 * item.count;
          data.partCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'tire') {
          data.tires += 1 * item.count;
          data.tireCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'other') {
          data.other += 1 * item.count;
          data.otherCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'sublet') {
          data.sublet += 1 * item.count;
          data.subletCost += this.calculationService.roundOff(item.subTotal);
        }
      });
    }

    return data;
  }

  setInspectionCounts(inspection: any = {}) {
    let categoryCount = 0;
    let itemCount = 0;
    let isItemExists = false;

    if (inspection.inspectionId && inspection.inspectionId.category && inspection.inspectionId.category.length) {
      inspection.inspectionId.category.forEach((category: any) => {
        if (category.inspectionItems.length) {
          category.inspectionItems.forEach(({ isChecked }: any) => {
            if (isChecked) {
              itemCount += 1;
              isItemExists = true;
            }
          });
        }

        if (isItemExists) {
          categoryCount += 1;
          isItemExists = false;
        }
      });
    }

    return {
      categoryCount,
      itemCount,
    };
  }

  formatDeferredServices(services: any[]) {
    services.forEach((service: any) => {
      const items = [];

      service.items.forEach((item: any, index: number) => {
        if (item.status) {
          items.push(item);
          item.isChecked = false;
          item.sitemId = index;
          item.quantity = this.helperService.renderItemQuantity(item);
          item.total = this.calculationService.roundOff(item.price * item.count);
        }
      });

      service.items = items;
      service.extra = this.setServiceTotals(service);

      if (service.inspection && service.inspection.inspectionId) {
        service.inspectionCount = this.setInspectionCounts(service.inspection);
      }

      return service.items && service.items.length;
    });

    return services;
  }

  /** Searching canned services locally */
  _searchCannedServices(value: string = '', forceTrigger: boolean = false) {
    if (value === this.query && !forceTrigger) {
      return;
    }

    this.dataService.sendData(
      this.dataService.typePassData('motor-on-search', {
        query: value.toLowerCase(),
      }),
    );

    this.query = value;
  }

  getSelectedInspections() {
    const services = Object.values(this.selectedInternalServices);
    const serviceInspections = [];

    services.forEach((service: any) => {
      serviceInspections.push({
        id: service._id,
        ...this.selectedServiceInspection[service._id],
        items: service.items,
      });
    });

    return serviceInspections;
  }

  getInternalSelectedService() {
    const services = Object.values(this.selectedInternalServices);
    if (services && services.length) {
      services.forEach((service: any) => {
        if (service.items && service.items.length) {
          service.items.forEach((item: any) => {
            if (item.type === 'bundle' && item.subItems && item.subItems.length) {
              item.subItems = item.subItems.filter((subItem: any) => {
                return subItem.isChecked === true;
              });
            }

            if (item.type === 'tire' && item.brand?.brandId && item.brand?.brandId !== 24) {
              delete item.brand.brandId;
            }
          });
        }
      });
    }
    return services;
  }

  getMotorSelectedService() {
    Object.keys(this.selectedMotorServices).forEach((key: any) => {
      this.selectedMotorServices[key].items.forEach((item: any) => {
        item.count = this.selectedMotorServices[key].itemCount[item.itemSourceId];
      });
    });

    Object.keys(this.selectedMaintenanceServices).forEach((key: any) => {
      this.selectedMaintenanceServices[key].items.forEach((item: any) => {
        item.count = this.selectedMaintenanceServices[key].itemCount[item.itemSourceId];
      });
    });
    return {
      ...this.selectedMotorServices,
      ...this.selectedMaintenanceServices,
    };
  }

  getMotorSelectedServiceNewGen() {
    Object.keys(this.selectedMotorServicesNewGen).forEach((key: any) => {
      this.selectedMotorServicesNewGen[key].items.forEach((item: any) => {
        if (this.selectedMotorServicesNewGen[key]?.itemCount?.length) {
          item.count = this.selectedMotorServicesNewGen[key].itemCount[item.itemSourceId];
        }
      });
    });

    Object.keys(this.selectedMaintenanceServices).forEach((key: any) => {
      this.selectedMaintenanceServices[key].items.forEach((item: any) => {
        item.count = this.selectedMaintenanceServices[key].itemCount[item.itemSourceId];
      });
    });

    return {
      ...this.selectedMotorServicesNewGen,
      // ...this.selectedMaintenanceServices, // Motor 2.0 Maintenance Services will be added in RO after they are implementated for Gen4.5
    };
  }

  handleSelectTab(activeTabIndex: number) {
    if (this.activeTabIndex === activeTabIndex) return;

    if (this.activeTabIndex === 4 || activeTabIndex === 4) {
      this.query = '';
    }

    if (activeTabIndex === 5 && !this.isMitchell1Connected) return;

    this.activeTabIndex = activeTabIndex;
    this.searchCannedServices(this.query, true);
    this.isSearchFieldFocused = true;

    if (this.dataService.isGainSightPXEnabled && activeTabIndex > 1 && activeTabIndex < 6) {
      let eventName = '';
      switch (activeTabIndex) {
        case 2:
          eventName = 'Motor Primary - Services';
          break;
        case 3:
          eventName = 'Motor Primary - Maintenance';
          break;
        case 4:
          eventName = 'Motor Primary - Code';
          break;
      }
      const payload = this.roNum
        ? {
            roNumber: this.roNum,
          }
        : {};
      this.helperService.postGainsightPXEvent(eventName, payload);
    }
  }

  validate() {
    let isValid = true;

    Object.keys(this.selectedMotorServices).forEach((key: any) => {
      this.selectedMotorServices[key].items.forEach((item: any) => {
        const count = Number(this.selectedMotorServices[key].itemCount[item.itemSourceId]);

        // validating whether the count is less than 1000 or not
        if (count > 1000) {
          isValid = false;
        }
      });
    });

    return isValid;
  }

  logPXGaingSightCustomEvent() {
    try {
      const data = this.helperService.getCompany();
      let flag = false;
      for (let keys of Object.keys(this.selectedMotorServices)) {
        if (this.selectedMotorServices[keys]?.items?.length > 0) {
          flag = true;
          break;
        }
      }
      const date = new Date();
      const dateTime = `${this.dateService.formatDate(date, datetimeFormat.mmmdyyyy)}, ${this.dateService.getTime(date)}`;
      if (flag) {
        const logInfo = {
          tenantName: this.companyData?.companyName,
          userName: this.companyData?.userName,
          triggerDateTime: dateTime,
        };
        this.helperService.logPXGaingSightEvent('Motor Primary Service(s) added to RO', logInfo);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  close(isSubmitted: any) {
    if (!this.validate()) {
      return;
    }

    if (isSubmitted) {
      const internalServices = this.getInternalSelectedService();
      internalServices.forEach((service: any) => {
      const isDeferred = this.deferredServices.some(d => d._id === service._id);
      const isCanned   = !isDeferred; 
      this.helperService.serviceEventGenerator(
        this.roNum,
        service.title ? service.title : service.titleFR,
        isDeferred,
        isCanned,
      );
      });
    }

    this.dynamicDialogRef.close({
      isSubmitted,
      data: this.getInternalSelectedService(),
      motorServices: this.getMotorSelectedService(),
      // motorServicesNewGen: this.getMotorSelectedServiceNewGen(),
      motorServicesNewGen: this.isMotorGen2Enabled ? this.getMotorSelectedServiceNewGen() : null,
      serviceInspections: this.getSelectedInspections(),
      motorVehicle: this.motorVehicle,
      deferredServices: this.deferredServices,
    });
    this.logPXGaingSightCustomEvent();
  }

  handleOpenMitchell1Guide() {
    if (this.isMitchell1Loading) return;

    this.isMitchell1Loading = true;
    this.httpService
      .getMitchell1GuideLink({ vehicleId: this.vehicle.vehicleId, searchTerm: encodeURIComponent(this.query) })
      .then(
        (url) => {
          if (url) {
            window.open(url, '', `width=${window.outerWidth},height=${window.outerHeight}`);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isMitchell1Loading = false;
      });
  }

  handleOpenMitchell1Estimator() {
    if (this.isMitchell1Loading) return;

    this.isMitchell1Loading = true;
    this.httpService
      .getMitchell1EstimatorToken({ vehicleId: this.vehicle && this.vehicle.vehicleId })
      .then(
        ({ token, mitchell1Vehicle }) => {
          const data = {
            vehicle: {
              year: '',
              make: '',
              model: '',
              subModel: '',
              engine: '',
              odometerUnit: '',
            },
            initialTab: 'PartsAndLabor',
          };

          if (mitchell1Vehicle) {
            data.vehicle.year = mitchell1Vehicle.year;
            data.vehicle.make = mitchell1Vehicle.make;
            data.vehicle.model = mitchell1Vehicle.model;

            // if (mitchell1Vehicle.submodel) {
            //   data.vehicle.subModel = mitchell1Vehicle.submodel;
            // }

            // if (mitchell1Vehicle.engine) {
            //   data.vehicle.engine = mitchell1Vehicle.engine;
            // }
          } else if (this.motorVehicle && this.motorVehicle.Year) {
            data.vehicle.year = this.motorVehicle.Year;
            data.vehicle.make = this.motorVehicle.MakeName;
            data.vehicle.model = this.motorVehicle.ModelName;
          } else {
            data.vehicle.year = this.vehicle.year;
            data.vehicle.make = this.vehicle.make;
            data.vehicle.model = this.vehicle.model;
          }

          if (this.mileage.unit && this.mileage.unit.value) {
            data.vehicle.odometerUnit = this.mileage.unit.value;
          }

          this.scriptLoaderService
            .loadScript('Mitchell1')
            .then((result) => {
              const { ShopIntegration, IntegrationManager } = window as any;
              const intent = new ShopIntegration.Intent(
                'mitchell1.intent.action.pick',
                // To Get Part & Labors
                'vendor/vnd.m1.partslabor.pick.v2',
                // To Resolve Vehicle
                // 'vendor/vnd.m1.resolvevehicle.pick.v1',
                data,
                { method: 'new', width: window.outerWidth, height: window.outerHeight },
              );
              IntegrationManager.start(intent, token);

              intent.onSuccess = (mitchell1Payload: any) => {
                // do something with the responseObject
                const ref = this.dialogService.open(Mitchell1ServiceAssignDialogComponent, {
                  width: '1200px',
                  showHeader: false,
                  data: {
                    itemsDetails: mitchell1Payload,
                    services: this.services,
                    customFleetSettings: this.customFleetSettings,
                  },
                  styleClass: 'add-dialog overflow-initial canned-service-dialog',
                });

                const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
                  if (isSuccess) {
                    this.dynamicDialogRef.close({
                      isSubmitted: true,
                      data: this.getInternalSelectedService(),
                      motorServices: this.getMotorSelectedService(),
                      serviceInspections: [],
                      mitchell1Services: data,
                      motorVehicle: this.motorVehicle,
                      deferredServices: this.deferredServices,
                    });
                  }

                  onClose.unsubscribe();
                });
              };

              intent.onFail = function (errorInformation) {
                if (isEmpty(errorInformation)) {
                  errorInformation = 'Unexpected error loading intent. Please inspect your browsers debugger for details.';
                }
                // log or display errorInformation
              };
            })
            .catch((err) => {
              console.log('error', err);
            });
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isMitchell1Loading = false;
      });
  }

  handleTabSelect(isMotor = false, serviceType = 1, type = '') {
    if (isMotor) {
      this.searchCannedServices(this.query, true);
      if (serviceType === 1) {
        this.serviceType = 1;
        this.activeTabIndex = 2;
        const eventName = 'Motor Primary - Services';
        const payload = this.roNum
          ? {
              roNumber: this.roNum,
              tenantName: this.companyData?.companyName,
              userName: this.companyData?.userName,
              date: this.dateService.formatDate(new Date(), datetimeFormat.mmmdyyyy),
              time: this.dateService.getTime(new Date()),
            }
          : {};
        this.helperService.postGainsightPXEvent(eventName, payload);
      }
      // moter 2.0
      if (serviceType === 2) {
        this.serviceType = 2;
        this.activeTabIndex = 5;
        const date = new Date();
        const dateTime = `${this.dateService.formatDate(date, datetimeFormat.mmmdyyyy)}, ${this.dateService.getTime(date)}`;
        const eventName = 'Motor Secondary - Services';
        const payload = this.roNum
          ? {
              roNumber: this.roNum,
              tenantName: this.companyData?.companyName,
              userName: this.companyData?.userName,
              triggerDateTime: dateTime,
            }
          : {};
        this.helperService.postGainsightPXEvent(eventName, payload);
      }
    } else {
      this.serviceType = 0;
      this.activeTabIndex = 0;

      // handle Qucik service
      if (type === 'quickService') {
        // 8 is using for Quickservice tab
        this.serviceType = serviceType;
        this.activeTabIndex = serviceType;
      }
    }
  }
}
